export default __webpack_public_path__ + "static/media/empty-state-documents.726ccbe2.svg";